import block from './block.json';

export const pageHeaderTwoColumnsThemeAttributes = {
	backgroundColor: '@tokens.variants.default.backgroundColor',
	padding: {
		top: [160, 240],
		bottom: [160, 240],
	},
	border: {
		color: 'transparent',
		width: {
			top: [0, 0],
			right: [0, 0],
			bottom: [0, 0],
			left: [0, 0],
		},
	},
	title: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-1',
		textAlignment: 'left',
	},
	introduction: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.heading-4',
		textAlignment: 'left',
	},
	text: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
};

export const PageHeaderTwoColumnsThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: pageHeaderTwoColumnsThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
